import axios from 'axios';
import { MAIL_API_URL } from 'appConfig';

export default axios.create({
  baseURL: MAIL_API_URL,
});
